import { PageTitle } from '../../../components';
import OrderLayout from '../components/OrderLayout';

const Order = () => {
  return (
    <>
      <PageTitle text="주문/결제" />
      {/*<OrderLayout cartState={} cartDispatch={} />*/}
    </>
  );
};

export default Order;
